import React, { useState } from 'react';

import { Download } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { downloadPdf } from 'shared/lib/downloadPdf';
import { toast } from 'sonner';

type Props = {
  /** API 경로. 예: /order/123/documents/payment-confirmation */
  path: string;
  filename: string;
  label: string;
  className?: string;
};

/** 결제 확인서·예약 내역서 같은 회원 본인 문서를 PDF로 내려받는 링크형 버튼. */
export const PdfDownloadButton = ({ path, filename, label, className }: Props) => {
  const { t } = useTranslation('common');
  const [isDownloading, setIsDownloading] = useState(false);

  const handleClick = async () => {
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      await downloadPdf(path, filename);
    } catch (error) {
      console.error('[PdfDownloadButton] download failed', error);
      toast.error(t('document.downloadFailed'));
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isDownloading}
      className={`inline-flex w-fit items-center gap-x-1.5 text-c2 text-gray-50 underline underline-offset-2 hover:text-primary disabled:opacity-50 ${className ?? ''}`}
    >
      <Download className="h-4 w-4 shrink-0" />
      {isDownloading ? t('document.downloading') : label}
    </button>
  );
};
